import Vue from 'vue'

// 全局轻量事件总线：用于跨组件通知登录态变化（如音乐卡片显示/隐藏）
const bus = new Vue()

export default bus
